
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-white via-[#f8fafc] to-[#f1f5f9] pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      <div className="relative z-10 text-center px-8 max-w-6xl mx-auto">
        <h2 className="text-7xl font-sans font-extralight text-[#1a1f36] leading-tight mb-8">
          Crafting Premium<br />iOS Applications<br />for Modern Users
        </h2>
        <p className="text-xl text-[#6b7280] font-light max-w-3xl mx-auto">
          Expert team developing innovative mobile solutions that enhance security and optimize performance
        </p>
      </div>
    </section>
  );
}
